import React from 'react';
import {withDynamicComponents} from 'higher-order-components';
import MakerSetOption from '../../containers/maker-set-option';
import MakerSetOptionMoreInfoItem from '../../containers/maker-set-option-more-info-item';

const MakerSetOptionBlock = props => <MakerSetOption {...props} />;
MakerSetOptionBlock.displayName = 'MakerSetOption';

export default withDynamicComponents({
  componentWhitelist: [
    MakerSetOptionMoreInfoItem,
  ],
  mapInputToOutput: [
    ['makerSetOptionMoreInfoItems', 'makerSetOptionMoreInfoItems'],
  ],
})(MakerSetOptionBlock);



// WEBPACK FOOTER //
// ./src/blocks/maker-set-option/index.jsx